export function decodeIfEncoded(str) {
  try {
    const decodedStr = decodeURIComponent(str);
    if (decodedStr !== str) {
      return decodedStr;
    }

    return str;
  } catch (e) {
    return str;
  }
}

export function getWelcomeCardBackgroundColor(process) {
  const { status, report_type } = process || {};
  const lowerStatus = status?.toLowerCase();

  if (lowerStatus === "completed") {
    return report_type === "avv"
      ? "#e6ffe6"
      : report_type === "avm"
      ? "#e6f7ff"
      : "#ffe6e6";
  } else if (status === "pending") {
    return "#ffffcc"; // light yellow for both "avv" and "avm"
  } else {
    return "#ffe6e6"; // light red for any other cases
  }
}

export const getBackgroundColor = (reportType, item) => {
  const status = reportType === "property" ? item?.avv?.status : item?.status;

  if (status?.toLowerCase() === "completed") {
    return "#e6ffe6"; // light green
  } else if (status === "pending") {
    return "#ffffcc"; // light yellow
  } else {
    return "#e6f7ff"; // default color
  }
};

export const toTitleCase = (str) => {
  return str
    ? str
        .toLowerCase()
        .split(" ")
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
        .join(" ")
    : str;
};

export function formatNumberWithCommas(x) {
  try {
    if (!x) return "-";
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  } catch (err) {
    return "-";
  }
}

export function formatDate(input) {
  if (input == null) {
    return "Invalid input";
  }

  let dateString = "";

  if (typeof input === "number") {
    dateString = input.toString();
  } else if (typeof input === "string") {
    dateString = input;
  } else {
    return "Invalid input";
  }

  const cleanDate = dateString.replace(/\D/g, "");

  if (cleanDate.length !== 8) {
    return "Invalid input";
  }

  const year = cleanDate.slice(0, 4);
  const month = cleanDate.slice(4, 6);
  const day = cleanDate.slice(6, 8);

  const numYear = parseInt(year);
  const numMonth = parseInt(month);
  const numDay = parseInt(day);

  if (
    numYear < 1000 ||
    numYear > 9999 ||
    numMonth < 1 ||
    numMonth > 12 ||
    numDay < 1 ||
    numDay > 31
  ) {
    return "Invalid date";
  }

  try {
    const date = new Date(numYear, numMonth - 1, numDay);
    if (isNaN(date.getTime())) {
      return "Invalid date";
    }

    return new Intl.DateTimeFormat("en-US", {
      month: "2-digit",
      day: "2-digit",
      year: "numeric",
    }).format(date);
  } catch {
    return `${month}/${day}/${year}`;
  }
}

export const formatLotSize = (data) => {
  const ACRE = 43560;

  let lotSize = data?.lot_size;
  let lotLabel = "LOT";

  if (lotSize >= ACRE) {
    lotSize = (lotSize / ACRE).toFixed(2);
    lotLabel = "LOT(ACRE)";
  } else {
    lotSize = `${lotSize}`;
  }

  return { lotSize, lotLabel };
};

export const formatLotSizePageTitle = (data) => {
  const ACRE = 43560;

  let lotSize = data?.lot_size;
  let lotLabel = "lot";

  if (lotSize >= ACRE) {
    lotSize = (lotSize / ACRE).toFixed(2);
    lotLabel = "lot(acre)";
  } else {
    lotSize = `${lotSize}`;
  }

  return { lotSize, lotLabel };
};
